import React, { ReactNode, FC, InputHTMLAttributes } from "react";
import styled from "styled-components";

const StyledForm = styled.form`
  display: flex;
  flex-direction: column;
  gap: 15px;
`;

const InputGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
`;

const Label = styled.label`
  font-weight: bold;
  color: ${({ theme }) => theme.text};
`;

const InputStyled = styled.input`
  padding: 10px;
  border: 1px solid ${({ theme }) => theme.border};
  border-radius: 4px;
  font-size: 16px;
  background: ${({ theme }) => theme.secondaryBackground};
  color: ${({ theme }) => theme.text};
  &::placeholder {
    color: #aaa;
  }
  &:focus {
    outline: none;
  }
`;

const Select = styled.select`
  padding: 10px;
  border: 1px solid ${({ theme }) => theme.border};
  border-radius: 4px;
  font-size: 16px;
  background: ${({ theme }) => theme.secondaryBackground};
  color: ${({ theme }) => theme.text};
`;

const SelectItem = styled.option`
  padding: 8px 12px;
  font-size: 16px;
  background: ${({ theme }) => theme.secondaryBackground};
  color: ${({ theme }) => theme.text};
  display: flex;
  align-items: center;

  /* Aqui garantimos que o conteúdo seja flexível */
  & svg {
    margin-right: 10px; /* Espaço entre o ícone e o texto */
  }
`;
const Range = styled.input`
  appearance: none;
  width: 100%;
  background: ${({ theme }) => theme.secondaryBackground};
  cursor: pointer;

  &::-webkit-slider-thumb {
    appearance: none;
    width: 15px;
    height: 15px;
    border-radius: 50%;
    background: ${({ theme }) => theme.text};
    cursor: pointer;
  }
`;

const Textarea = styled.textarea`
  color: ${({ theme }) => theme.text};
  background: ${({ theme }) => theme.secondaryBackground};
  padding: 10px;
  border: 1px solid ${({ theme }) => theme.border};
  border-radius: 4px;
  font-size: 16px;
  resize: vertical;
`;

const Checkbox = styled.input.attrs({ type: "checkbox" })`
  width: 18px;
  height: 18px;
`;

const Radio = styled.input.attrs({ type: "radio" })`
  width: 18px;
  height: 18px;
`;

const FileInput = styled.input.attrs({ type: "file" })`
  padding: 5px;
  font-size: 14px;
  color: ${({ theme }) => theme.text};
`;

interface FormComponent extends FC<FormProps> {
  Group: typeof InputGroup;
  Label: typeof Label;
  Input: FC<InputProps>;
  TextArea: typeof Textarea;
  Select: typeof Select;
  SelectItem: typeof SelectItem;
  Range: typeof Range;
  Checkbox: typeof Checkbox;
  Radio: typeof Radio;
  FileInput: typeof FileInput;
}

interface FormProps extends React.HTMLAttributes<HTMLFormElement> {
  children: ReactNode;
  onSubmit?: (event: React.FormEvent<HTMLFormElement>) => void;
}

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  children?: ReactNode;
}

const Form: FormComponent = ({ children, ...props }: FormProps) => {
  return <StyledForm {...props}>{children}</StyledForm>;
};

Form.Input = ({ ...props }: InputHTMLAttributes<HTMLInputElement>) => (
  <InputStyled {...props} />
);

Form.Group = InputGroup;
Form.Label = Label;
Form.TextArea = Textarea;
Form.Select = Select;
Form.SelectItem = SelectItem;
Form.Range = Range;
Form.Checkbox = Checkbox;
Form.Radio = Radio;
Form.FileInput = FileInput;

export default Form;
